
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/data-engineering",
      function () {
        return require("private-next-pages/solutions/data-engineering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/data-engineering"])
      });
    }
  